import {IWrapper} from '../types';
import {IUserConfig, UserConfigResponse} from '../types/endpoints';

/**
 * UserConfigEndpoint class implements IUserConfig interface.
 */
class UserConfigEndpoint implements IUserConfig {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param {IWrapper} wrapper - The wrapper instance.
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get user config
   * @returns {Promise<UserConfigResponse>} - The user configuration.
   */
  public getUserConfig(): Promise<UserConfigResponse> {
    return this.wrapper.get<UserConfigResponse>('/v2/user-configurations');
  }
}

export default UserConfigEndpoint;
